<template>
	<svg xmlns="http://www.w3.org/2000/svg" @click="clicked" v-if="active" id="active" viewBox="0 0 1010 1010" width="25" height="25">
		<rect class="cls-1" x="518.4" y="521.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-1" x="296.4" y="521.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-1" x="296.4" y="301.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-1" x="518.4" y="301.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-2" x="20" y="20" width="970" height="970" rx="169.46" />
	</svg>
	<svg xmlns="http://www.w3.org/2000/svg" @click="clicked" id="inactive" viewBox="0 0 1010 1010" width="25" height="25" v-else>
		<rect class="cls-1" x="20" y="20" width="970" height="970" rx="169.46" />
		<rect class="cls-2" x="518.4" y="521.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-2" x="296.4" y="521.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-2" x="296.4" y="301.41" width="196.6" height="196.59" rx="21.29" />
		<rect class="cls-2" x="518.4" y="301.41" width="196.6" height="196.59" rx="21.29" />
	</svg>
</template>

<script>
	export default {
		name: 'SquareSVG',
		props: {
			active: Boolean
		},
		methods: {
			clicked() {
				this.$emit('click');
			}
		}
	};
</script>

<style scoped lang="scss">
	#active {
		.cls-1 {
			fill: #231e21;
		}
		.cls-2 {
			fill: none;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
	}
	#inactive {
		.cls-1 {
			fill: #231e21;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
		.cls-2 {
			fill: #fff;
		}
	}
</style>
